import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_DISCHARGE_DISPOSITION = "GET_DISCHARGE_DISPOSITION";

export const service = async () => {
  const options: object = {
    url: "/api/DischageDisposition/GetDischageDisposition",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_DISCHARGE_DISPOSITION, service, mock);
